/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { Edit, InfoRound } from '@rsuite/icons';

import { Table, FlexboxGrid, IconButton } from 'rsuite';
import { toast } from 'react-toastify';
import { Container } from '~/styles/tabela1';

import api from '~/services/api';
import SelectState from '~/components/SelectState';

import { InputData } from '~/components/InputData';
import { FiltroTreinamentos } from '~/components/FiltroTreinamentos';
import { FiltroExperiencias } from '~/components/FiltroExperiencias';
import { TabelaPaginacao } from '~/components/TabelaPaginacao';
import { TableHeaderTooltip, TablePagination } from '~/components/TablePagination1';
import { MdOutlinePeopleOutline, MdWorkOutline } from 'react-icons/md';
import { IoMdCheckmarkCircleOutline } from 'react-icons/io';
import { FaRegStar } from 'react-icons/fa';
import EditarProfissional from '../../Profissionais/EditarProfissional';
import DetalhesCarteiraDialog from '../CarteiraProfissionais/components/DetalhesCarteiraDialog';
import PageHeader from '../../../components/PageHeader';
import MetricsCards from '../../../components/MetricCards';
import AdvancedFilters from '../../../components/AdvancedFilters';

const { HeaderCell, Column, Cell } = Table;

function RelatoriosProfissional() {
  const [filtroData, setFiltroData] = useState(new Date());
  const [data, setData] = useState();
  const [relatorios, setRelatorios] = useState({
    lista: [],
    quantidade: 0,
  });
  const [experiencias, setExperiencias] = useState([]);
  const [experienciaSelecionada, setExperienciaSelecionada] = useState();
  const [treinamentos, setTreinamentos] = useState([]);
  const [treinamentoSelecionado, setTreinamentoSelecionado] = useState();
  const [pagina, setPagina] = useState(1);
  const [carregando, setCarregando] = useState(false);
  const [estadoSelecionado, setEstadoSelecionado] = useState();
  const [ufSelecionado, setUfSelecionado] = useState();
  const [exibirDetalhesDialog, setExibirDetalhesDialog] = useState({
    exibir: false,
  });
  const [profissionalEditando, setProfissionalEditando] = useState();
  const [showEditarProfissional, setShowEditarProfissional] = useState(false);
  const [orderBy, setOrderBy] = useState();

  const locale = {
    sunday: 'Dom',
    monday: 'Seg',
    tuesday: 'Ter',
    wednesday: 'Qua',
    thursday: 'Qui',
    friday: 'Sex',
    saturday: 'Sab',
    ok: 'Ok',
    today: 'Hoje',
    yesterday: 'Ontem',
    hours: 'Horas',
    minutes: 'Minutos',
    seconds: 'Segundos',
  };

  const buscarRelatorios = useCallback(async () => {
    setCarregando(true);
    try {
      const resposta = await api.get('relatorios/profissionais-disponiveis', {
        params: {
          diaSemana: filtroData,
          pagina,
          estado: estadoSelecionado,
          experiencias: experienciaSelecionada,
          treinamentos: treinamentoSelecionado,
        },
      });

      const experiencias1 = await api.get('profissao');
      setExperiencias(experiencias1.data);
      const treinamentos1 = await api.get('treinamento');
      setTreinamentos(treinamentos1.data);

      const { lista } = resposta.data;
      setRelatorios({
        lista,
        quantidade: lista.length > 0 ? lista[0].full_count : 0,
      });
      if (relatorios.quantidade === 0) setPagina(1);
    } catch (e) {
      toast.error(e.message);
    }

    setCarregando(false);
  }, [
    pagina,
    filtroData,
    estadoSelecionado,
    experienciaSelecionada,
    treinamentoSelecionado,
    setPagina,
    relatorios.quantidade,
  ]);

  useEffect(() => {
    buscarRelatorios();
  }, [buscarRelatorios]);

  function abrirEditarProfissional(profissional) {
    setProfissionalEditando(profissional);
    setShowEditarProfissional(true);
  }

  function fecharEditarProfissional() {
    buscarRelatorios();
    setShowEditarProfissional(false);
  }

  const activeFilters = useMemo(() => {
    const filters = [];
    // if (filtroData) {
    //   filters.push({
    //     key: 'Data',
    //     label: `Data: ${filtroData.toLocaleDateString('pt-BR')}`,
    //     clear: () => setFiltroData(new Date()),
    //   });
    // }
    if (estadoSelecionado) {
      filters.push({
        key: 'Estado',
        label: `Estado: ${ufSelecionado || estadoSelecionado}`,
        clear: () => {
          setEstadoSelecionado(undefined);
          setUfSelecionado(undefined);
        },
      });
    }
    if (experienciaSelecionada?.length) {
      // const experiencia = experiencias.find(
      //   (exp) => exp.id === experienciaSelecionada
      // );
      filters.push({
        key: 'Experiência',
        label: `${experienciaSelecionada.length} experiência(s)`,
        clear: () => setExperienciaSelecionada(undefined),
      });
    }
    if (treinamentoSelecionado) {
      // const treinamento = treinamentos.find(
      //   (t) => t.id === treinamentoSelecionado
      // );
      filters.push({
        key: 'Treinamento',
        label: `${treinamentoSelecionado.length} treinamento(s)`,
        clear: () => setTreinamentoSelecionado(undefined),
      });
    }
    return filters;
  }, [
    filtroData,
    estadoSelecionado,
    experienciaSelecionada,
    experiencias,
    treinamentoSelecionado,
    treinamentos
  ]);


  return (
    <Container>
      <PageHeader
        title="Profissionais Disponíveis"
        subtitle="Aqui você pode ver todos os profissionais disponíveis para trabalhar."
      />
      <MetricsCards
        items={[
          {
            title: 'Total de Profissionais',
            value: relatorios.quantidade,
            icon: <MdOutlinePeopleOutline size='30px' />,
            background: '#EFF6FF',
            color: '#2563EB'
          },
          {
            title: 'Perfil Completo',
            value: '-',
            icon: <IoMdCheckmarkCircleOutline size='30px' />,
            background: '#ECFDF3',
            color: '#16A34A'
          },
          {
            title: 'Trabalharam',
            value: '-',
            icon: <MdWorkOutline size='30px' />,
            background: '#F3E8FF',
            color: '#7C3AED'
          },
          {
            title: 'Interessados',
            value: '-',
            icon: <FaRegStar size='30px' />,
            background: '#FFF7ED',
            color: '#EA580C'
          },
        ]}
      />
      <AdvancedFilters
        activeFilters={activeFilters}
        header={
          <InputData
            cleanable={false}
            ranges={[]}
            isoWeek
            oneTap
            locale={locale}
            value={filtroData}
            onChange={setFiltroData}
            style={{ marginRight: '0px' }}
          />
        }
      >

        <SelectState
          selectedState={estadoSelecionado}
          setSelectedStates={setEstadoSelecionado}
          setUfSelecionado={setUfSelecionado}
        // marginRight
        />
        <FiltroExperiencias
          style={{ width: 224 }}
          appearance="default"
          data={experiencias.map((profissao) => ({
            label: profissao.profissao,
            value: profissao.id,
          }))}
          value={experienciaSelecionada}
          onChange={(value) => setExperienciaSelecionada(value)}
        />
        <FiltroTreinamentos
          appearance="default"
          style={{ marginRight: '15px', width: 224 }}
          searchable={false}
          data={treinamentos.map((treinamento) => ({
            label: treinamento.treinamento,
            value: treinamento.id,
          }))}
          value={treinamentoSelecionado}
          onChange={(value) => setTreinamentoSelecionado(value)}
        />
      </AdvancedFilters>
      <FlexboxGrid style={{ width: '100%' }}>
        {/* <TabelaPaginacao */}
        <TablePagination
          carregando={carregando}
          dados={relatorios.lista}
          quantidade={relatorios.quantidade}
          onChangePage={setPagina}
        // setOrderBy={setOrderBy}
        >
          <Column resizable width={100}>
            <HeaderCell>
              <TableHeaderTooltip label='Ações' tooltip='Ações' />
            </HeaderCell>
            <Cell dataKey="id" style={{ padding: '5px' }}>
              {(rowData) => (
                <>
                  <IconButton
                    title="Detalhes"
                    appearance="subtle"
                    onClick={() => {
                      setExibirDetalhesDialog({
                        exibir: true,
                        id_profissional: rowData.id,
                      });
                    }}
                    icon={<InfoRound />}
                  />
                  <IconButton
                    title="Editar"
                    appearance="subtle"
                    onClick={() => {
                      abrirEditarProfissional(rowData);
                    }}
                    icon={<Edit />}
                  />
                </>
              )}
            </Cell>
          </Column>
          <Column resizable width={250}>
            <HeaderCell>
              <TableHeaderTooltip label='Nome' tooltip='Nome' />
            </HeaderCell>
            <Cell dataKey="nome" />
          </Column>
          <Column resizable width={150}>
            <HeaderCell>
              <TableHeaderTooltip label='CPF' tooltip='CPF' />
            </HeaderCell>
            <Cell dataKey="cpf_cnpj" />
          </Column>
          <Column resizable width={150}>
            <HeaderCell>
              <TableHeaderTooltip label='Telefone' tooltip='Telefone' />
            </HeaderCell>
            <Cell dataKey="telefone1" />
          </Column>
          <Column resizable width={200}>
            <HeaderCell>
              <TableHeaderTooltip label='Cidade' tooltip='Cidade' />
            </HeaderCell>
            <Cell dataKey="cidade" />
          </Column>
          <Column resizable width={100}>
            <HeaderCell>
              <TableHeaderTooltip label='Estado' tooltip='Estado' />
            </HeaderCell>
            <Cell dataKey="uf" />
          </Column>
        </TablePagination>
        {/* </TabelaPaginacao> */}
      </FlexboxGrid>
      <DetalhesCarteiraDialog
        exibir={exibirDetalhesDialog.exibir}
        id_profissional={exibirDetalhesDialog.id_profissional}
        datas={data}
        onFechar={() => setExibirDetalhesDialog({ exibir: false })}
      />
      <EditarProfissional
        idProfissional={profissionalEditando && profissionalEditando.id}
        showEditarProfissional={showEditarProfissional}
        setShowEditarProfissional={setShowEditarProfissional}
        fecharEditarProfissional={fecharEditarProfissional}
        atualizarLista={buscarRelatorios}
      />
    </Container>
  );
}

export default RelatoriosProfissional;
